import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HiperhidrosePage from './pages/HiperhidrosePage';
import NoduloPulmonarPage from './pages/NoduloPulmonarPage';

// Detecta o subdomínio de forma ampla (inclui qualquer variação de "nodulo")
const hostname = window.location.hostname;
const isNoduloSubdomain = hostname.includes('nodulo');

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota raiz: mostra página correta conforme subdomínio, sem redirecionamento */}
        <Route
          path="/"
          element={isNoduloSubdomain ? <NoduloPulmonarPage /> : <HiperhidrosePage />}
        />
        {/* Rota explícita para nódulo (funciona nos dois subdomínios) */}
        <Route path="/nodulo-pulmonar" element={<NoduloPulmonarPage />} />
        {/* Qualquer outra rota volta para a raiz */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
